<script setup>
const { $auth } = useNuxtApp()
const route = useRoute()

const props = defineProps({
  verificationEmail: {
    type: String,
    default: '',
  },
})

const isLoading = ref(false)
const resendMessage = ref('')
const normalizedEmail = computed(() => props.verificationEmail?.trim() || '')
const displayVerificationEmail = computed(
  () => normalizedEmail.value || 'your email address',
)

const resendEmailVerification = async () => {
  const email = normalizedEmail.value
  if (!email) {
    resendMessage.value = 'Missing email address. Please return and try again.'
    return
  }

  isLoading.value = true
  try {
    const nextPath = $auth.authRedirect || route.fullPath
    await $auth.resendEmailConfirmationEmail({
      email,
      next: nextPath,
    })
    resendMessage.value = `Verification email sent to ${displayVerificationEmail.value}.`
  } catch (e) {
    const apiError = e?.data?.error || e?.errors?.non_field_errors?.[0]
    resendMessage.value =
      apiError || 'Unable to resend verification email. Please try again.'
  } finally {
    isLoading.value = false
  }
}
</script>

<template>
  <div class="standard-form form-container ep-email-verify">
    <h2 class="f20">Verify Your Email</h2>
    <div class="ep-email-verify__body">
      <p>
        Please verify <b>{{ displayVerificationEmail }}</b> to continue. This
        helps us keep Wine Access secure.
      </p>
      <p>
        We sent a verification email with a link to confirm your account. Once
        verified, you will be returned to the En Primeur to complete your order.
      </p>
      <p class="left-login-error ep-email-verify__hint">
        Don’t see the email? Check your spam folder or request a new one.
      </p>
      <p v-if="resendMessage" class="left-login-error">{{ resendMessage }}</p>
      <div class="left-login-button">
        <button
          type="button"
          class="primary"
          :disabled="isLoading"
          @click="resendEmailVerification"
        >
          {{ isLoading ? 'Sending...' : 'Resend Verification' }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ep-email-verify {
  text-align: left;
}

.ep-email-verify__body {
  padding-left: 0.9375rem;
}

.ep-email-verify__hint {
  color: #a01f1d;
}

.ep-email-verify .left-login-button {
  justify-content: flex-start;
}

.ep-email-verify .left-login-button button {
  margin: 0;
}
</style>
